



































import { Component, Prop, Mixins, PropSync, Emit } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { CustomerDto, PromotionListFilter } from '@/services/connecteur'
import userModule from '@/store/modules/UserModule'
import salesOrgsModule from '@/store/modules/SalesOrgsModule'
import promotionModule from '@/store/modules/PromotionModule'
import DateRangePicker from '@/components/shared/DateRangePicker.vue'
import ListOptionFilter from '@/components/Promotions/Filter/ListOptionFilter.vue'
import SelectFilter from '@/components/Promotions/Filter/SelectFilter.vue'

@Component({
  components: {
    DateRangePicker,
    ListOptionFilter,
    SelectFilter
  }
})
export default class PromotionFilter extends Mixins(BaseVue) {
  @Prop({ default: [], type: Array })
  customerChoice!: CustomerDto[]

  public filterSync: PromotionListFilter = promotionModule.filter

  public get userIsReportingUser () {
    return userModule.userIsReportingUser
  }

  public get salesOrgList () {
    return salesOrgsModule.salesOrgsWithoutDisabled
  }

  public get allStatusName () {
    return promotionModule.allStatusName
  }

  public get cmmfGroupName () {
    return promotionModule.cmmfGroupName
  }

  @Emit('updateData')
  updateDataList (changeOption?: number | undefined) {
    promotionModule.updateFilter(this.filterSync)
    return changeOption
  }
}
